/* eslint-disable formatjs/no-literal-string-in-jsx */
import Button from '@atlaskit/button';
import SearchIcon from '@atlaskit/icon/core/search';
import { token } from '@atlaskit/tokens';
import { SkeletonItem } from '@databases/skeleton';
import { range } from 'lodash-es';
import React, { type FunctionComponent } from 'react';
import styled from 'styled-components';

import { ButtonGroup } from '../styled';

import { ToolbarContainer } from './toolbars/styled';
import { SearchFieldTransition } from './view-settings-picker/QuickSearch';

const StyledToolbarContainer = styled(ToolbarContainer)`
  padding-bottom: ${token('space.025', '2px')} !important;
  border-bottom: 1px solid ${token('color.border', '#091E4224')} !important;
`;

const VerticalDivider = styled.div`
  width: 1px;
  background-color: ${token('color.border', '#091E4224')};
  margin-left: ${token('space.200', '16px')};
`;

const ViewTabsWrapper = styled.div`
  height: 24px;
  display: flex;
  margin-left: ${token('space.100')};
`;

const ToolbarSkeleton: FunctionComponent = () => {
  const viewTabs = (
    <ViewTabsWrapper>
      <SkeletonItem hasIcon height={16}>
        View Tab Elem Name
      </SkeletonItem>
      <VerticalDivider />
      <SkeletonItem isButton height={16} width={16}>
        <Button>Add</Button>
      </SkeletonItem>
    </ViewTabsWrapper>
  );

  const toolbar = (
    <ButtonGroup align="spaced" style={{ marginBottom: token('space.100') }}>
      <ButtonGroup>
        <SkeletonItem isButton height={16}>
          <SearchFieldTransition expanded={false}>
            <Button iconBefore={<SearchIcon label="" />}>Search</Button>
          </SearchFieldTransition>
        </SkeletonItem>
        <SkeletonItem isButton height={16}>
          <Button />
        </SkeletonItem>
      </ButtonGroup>
    </ButtonGroup>
  );

  const viewSettingsButtons = (
    <ButtonGroup
      style={{
        marginBottom: token('space.075', '6px'),
        marginLeft: token('space.100'),
        marginTop: token('space.075', '6px')
      }}
    >
      {range(4).map((i) => (
        <SkeletonItem isButton height={24} key={i}>
          <Button>View Button</Button>
        </SkeletonItem>
      ))}
    </ButtonGroup>
  );

  return (
    <>
      <StyledToolbarContainer>
        {viewTabs}
        <div className="expand" />
        {toolbar}
      </StyledToolbarContainer>

      {viewSettingsButtons}
    </>
  );
};

export default ToolbarSkeleton;
